<!--
 * @Author: cryi.liu
 * @Date: 2020-06-17 13:55:42
 * @LastEditTime: 2020-06-17 14:00:26
 * @Description: 阅卷分页
-->
<template>
  <i-page
    :total="total"
    :current="page.index"
    :page-size="page.size"
    size="small"
    show-elevator show-total @on-change="pageIndexChanged" />
</template>

<script>
export default {
  name: 'MarkPage',
  props: {
    page: { type: Object, required: true },
    total: { type: Number, required: true },
  },
  methods: {
    /**
     * 分页索引改变处理函数
     */
    pageIndexChanged(index) {
      this.$emit('index-change', index);
    },
  },
};
</script>

<style lang="less" scoped>
.mark-page {
  width: 100%;
}
</style>
